<template>
  <b-container fluid>
    <b-row>
      <div class="p-3" v-for="card in $store.getters.cards" :key="card.id">
        <div
          class="cBody"
          :style="`width: ${$parent.cardImgWidth}rem; height: ${$parent.cardImgHeight}rem;`"
        >
          <div class="cPhoto p-1">
            <b-img-lazy class="cImg" :src="`/api/v1/people/${card.id}/photo/profile?type=preview`"/>
          </div>
          <div class="cTitle px-2">{{card.id}}. {{card.name}}</div>
          <div v-if="false" class="cText m-2">Doplnkovy text nad menom - pre pripad potreby</div>

          <div>
            <b-button
              v-if="$parent.cardBtnDetail"
              @click="peopleDetailModal(card.id)"
              variant="warning"
              class="cBtn m-1"
            >&#128269;</b-button>

            <span v-if="$parent.cardBtnAddToSelection">
              <b-button
                v-if="!$parent.peopleInSelection.includes(card.id)"
                @click="addToSelection(card.id)"
                variant="success"
                class="m-1 cBtn float-right"
              >&#10133;</b-button>
            </span>

            <span v-on:click="changeStatus($store.getters.selectionSelect.id, card.id)">
              <b-img-lazy
                v-if="$store.getters.selectionSelect.id"
                style="position: relative; z-index: 2; "
                width="40px"
                :id="`confirmStatusImg-${card.id}`"
                height="40px"
                :src="`/api/v1/selection/${$store.getters.selectionSelect.id}/${card.id}/statusicon`"
              />
            </span>

            <b-button
              v-if="$parent.cardBtnRemoveFromSelection && !$store.getters.selectionShowClosed"
              @click="removeFromSelectionDialog(card.id)"
              variant="primary"
              class="m-1 cBtn float-right"
            >&#10134;</b-button>
          </div>
        </div>
      </div>
    </b-row>

    <!-- Modal dialog osoby -->
    <b-modal
      v-if="showModal"
      hide-footer
      v-model="showModal"
      v-on:close="showGallery = false"
      v-bind:no-close-on-esc="disableEsc"
      size="xl"
      scrollable
      ref="peopleDetailModal"
      :title="'Detail osoby: ' + peopleDetail.id + '. ' + peopleDetail.degree + ' ' + peopleDetail.name"
    >
      <b-tabs content-class="mt-3">
        <!-- Tab s informacemi osoby spadajici do vyberu -->
        <b-tab v-if="$parent.selectionNotesTab" title="Informace" active>
          <PeopleSelectionNotes
            :peopleID="peopleDetail.id"
            :peoplePhone="peopleDetail.contactPhone"
            v-on:requestSave="function(value) {$refs['peopleDetailModal'].hide()}"
          />
        </b-tab>

        <!-- Tab s vypisem zakladnich vlastnosti osoby -->
        <b-tab title="Detail">
          <b-button
            variant="primary"
            size="sm"
            class="mr-3"
            :to="'/people-edit/'+peopleDetail.id+'/0/'"
          >Editovat</b-button>
          <b-button variant="primary" size="sm" class @click="exportPDF">PDF</b-button>
          <hr>
          <PeopleDetail :peopleDetail="peopleDetail"/>
        </b-tab>

        <!-- Tab s vypisem vsech fotek osoby -->
        <b-tab @click="showGallery = true" title="Galerie">
          <b-row>
            <b-button
              variant="primary"
              size="sm"
              class="mx-3"
              :to="'/people-edit/'+peopleDetail.id+'/1/'"
            >Editovat</b-button>
          </b-row>
          <hr>
          <b-row>
            <Gallery
              v-if="showGallery"
              v-on:disableEsc="function(value) {disableEsc = value}"
              :peopleDetail="peopleDetail"
              :showDeleteBtn="false"
            />
          </b-row>
        </b-tab>

        <!-- Tab se seznamem priloh k osobe -->
        <b-tab title="Přílohy">
          <b-row class="pb-2">
            <b-button
              variant="primary"
              size="sm"
              class="mx-3"
              :to="'/people-edit/'+peopleDetail.id+'/2/'"
            >Editovat</b-button>
          </b-row>
          <b-row>
            <Files :peopleDetail="peopleDetail" :showDeleteBtn="false"/>
          </b-row>
        </b-tab>
        <b-tab title="SMS">
          <b-row>
            <SMS
              :peopleDetail="peopleDetail"
              v-on:closeSMS="function (){$refs['peopleDetailModal'].hide()}"
            />
          </b-row>
        </b-tab>
      </b-tabs>
      <div slot="modal-footer" class="w-100"></div>
    </b-modal>

    <b-modal ref="confirmRemoveFromSelection" title="Skutečne odebrat z výběru??">
      <template slot="modal-footer">
        <b-button size="sm" variant="danger" @click="removeFromSelection()">Odebrat</b-button>
        <b-button
          size="sm"
          variant="success"
          @click="$refs['confirmRemoveFromSelection'].hide()"
        >Zrušit</b-button>
      </template>
    </b-modal>
  </b-container>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import PeopleDetail from '@/components/peopleDetail.vue'
import PeopleSelectionNotes from '@/components/peopleSelectionNotes.vue'
// import Gallery from '@/components/gallery'
import Files from '@/components/files'
import SMS from '@/components/sms.vue'

export default Vue.extend({
  props: {
    selectionSelected: null
  },
  components: {
    PeopleSelectionNotes,
    PeopleDetail,
    Gallery: () => import('@/components/gallery'),
    Files,
    SMS
  },
  data () {
    return {
      showGallery: false, // NAcitat galeriu LEN pri kliku na tab galerie
      showModal: false,
      peopleDetail: null,
      cardForRemoveFromSelection: null,
      disableEsc: false // Disable ESC pre Modal ked je otvorena galeria (aby sa jednym ESC nezatvaral aj Modal)
    }
  },
  mounted () {

  },
  methods: {
    changeStatus (selectionID, cardID) {
      axios
        .put(`/api/v1/selection/${selectionID}/${cardID}/confirmed-change`)
        .then(response => {
          const flag = document.getElementById(`confirmStatusImg-${cardID}`)
          let src = flag.src
          flag.src = src
        })
        .catch(err => { console.log(err.response.data.message) })
    },
    removeFromSelectionDialog (cardID) {
      this.$refs['confirmRemoveFromSelection'].show()
      this.cardForRemoveFromSelection = cardID
    },
    peopleDetailModal (ID) {
      axios
        .get(`/api/v1/people/${ID}?hr=true`)
        .then(response => {
          this.peopleDetail = response.data
          this.showModal = true
        })
        .catch(response => {
          console.log('peopleDetailModal - error: ' + response)
        })
    },
    addToSelection (ID) {
      if (this.selectionSelected != null) {
        axios.post(`/api/v1/selection/${this.selectionSelected}/${ID}`)
          .then(this.$parent.peopleInSelection.push(ID))
      } else {
        alert('Vyberte projekt!!!')
      }
    },
    removeFromSelection () {
      if (this.$store.getters.selectionSelect.id != null) {
        axios.delete(`/api/v1/selection/${this.$store.getters.selectionSelect.id}/${this.cardForRemoveFromSelection}`)
          .then(() => {
            axios
              .get('/api/v1/people', {
                params: {
                  selection: this.$store.getters.selectionSelect.id
                }
              })

              .then(response => {
                this.$refs['confirmRemoveFromSelection'].hide()
                this.$store.commit('cards', response.data)
              })
              .catch(response => {
                this.$refs['confirmRemoveFromSelection'].hide()
                alert('error', response)
              })
          })
      } else {
        alert('Vyberte projekt!!!')
      }
    },
    exportPDF () {
      axios({
        url: `/api/v1/export/people/${this.peopleDetail.id}/pdf`,
        method: 'GET',
        responseType: 'blob' // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'unknown'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) { fileName = fileNameMatch[1] }
        }
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
      })
    }
  }
})
</script>

<style>
.cBody {
  background-color: white;
  border: 0px solid rgb(133, 116, 116);
  border-radius: 0px;
  box-shadow: 10px 10px 0.4em 0 rgb(210, 210, 210);
  display: flex;
  flex-direction: column;
}

.cTitle {
  display: flex;
  font-weight: bold;
  height: 1.4em;
  overflow: hidden;
}

.cPhoto {
  display: flex;
  flex: 1;
  min-height: 0;
  background-image: radial-gradient(
    rgb(220, 220, 220) 30%,
    rgb(255, 255, 255) 75%
  );
}

.cImg {
  object-fit: contain;
  width: 100%;
  height: 100%;
}

.cText {
  height: 1.4em;
  overflow: hidden;
}

.cBtn {
  justify-content: center;
  align-items: center;
  border-radius: 0px;
}
</style>
